import {Component, Input, OnInit} from '@angular/core';
import {ToastsService} from "../../../services/toasts.service";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {saveAs} from 'file-saver';
import {environment} from "../../../../environments/environment";

declare var UIkit: any;

@Component({
  selector: 'app-download-shipment-labels-modal',
  templateUrl: './download-shipment-labels-modal.component.html',
  styleUrls: ['./download-shipment-labels-modal.component.scss']
})
export class DownloadShipmentLabelsModalComponent implements OnInit {
  @Input('internalNumber') internalNumber: string = null;

  private backendServerUrl: string;

  constructor(
    private router: Router,
    private http: HttpClient,
    private toastsService: ToastsService,
  ) {
    this.backendServerUrl = environment.api.replace(/\/api\/?$/, "");
  }

  ngOnInit(): void {
  }

  downloadFile(paperSize) {
    this.http.get(
      this.backendServerUrl + '/app/v2/shipment/' + this.internalNumber +'/labels/' + paperSize,
      {responseType: 'blob'}
    ).subscribe(
      (response: any): void => {
        const blob = new Blob([response], {type: response.type.toString()});
        const objUrl = window.URL.createObjectURL(blob);
        saveAs(blob, this.internalNumber + '.pdf');
      },
      (): void  => {
        UIkit.modal('#downloadShipmentLabelsModal').hide();
        this.toastsService.showMessage('Twoja etykieta nie jest jeszce gotowa!', 'w');
      }
    );
  }

  addNextShipment(): void {
    UIkit.modal('#downloadShipmentLabelsModal').hide();
    this.router.navigateByUrl('shipment/new');
  }
}
